export default "__VITE_ASSET__a4044623__"